import { useEffect } from 'react';

import { captureAndStoreUTMParams } from '@eneco/common/querystring/utmStorage';

/**
 * Component that captures and stores UTM parameters on mount.
 * Uses last-touch attribution (always overwrites with latest UTMs).
 * Safe for SSR (checks for window before accessing).
 */
export const UTMCapture: React.FC = () => {
  useEffect(() => {
    captureAndStoreUTMParams();
  }, []);

  return null;
};
